angular.module('mtic.components.notifications')
.directive('teacherUpdates', function ($log, EventManager, $timeout, language, userAccount, api, notificationService) {
  return {
    templateUrl: 'template.html',
    scope: {
        dismissed: '='
    },
    link: function (scope) {
      var eventManager = new EventManager('teacherUpdates');
      scope.getTranslation = function(slug){
        return language.get(slug);
      }
      scope.isTeacher = userAccount.getData().role.isTeacher;
      scope.show_teacher_info_popup = true;
      scope.whatsNew = {
        showAgendaModule: true,
        agenda_pages: [
          {
            page:'welcome',
            header: '27707' // welcome to Mathematic's newest update!
          },
          {
            page:'design',
            header: '27713' // 'Design'
          },
          {
            page:'agenda1',
            header: '27714' // 'Agenda'
          },
          {
            page:'agenda2',
            header: '27714' // 'Agenda'
          },
          {
            page:'agenda3',
            header: '27714' // 'Agenda'
          },
          {
            page:'agenda4',
            header: '27714' // 'Agenda'
          },
          {
            page:'agenda5',
            header: '27714' // 'Agenda'
          }
        ],
        cur_index: 0,
        agenda_current_page: {
          page:'welcome',
          header: '27707' // welcome to Mathematic's newest update!
        },
        move_page: function(index){
          var new_index = scope.whatsNew.cur_index + index;
          if(new_index > -1 && new_index < scope.whatsNew.agenda_pages.length){
            scope.whatsNew.agenda_current_page = scope.whatsNew.agenda_pages[new_index];
            scope.whatsNew.cur_index = new_index
          }else if(new_index >= scope.whatsNew.agenda_pages.length){
            scope.whatsNew.close();
          }
        },
        get_button_state: function(continue_btn){
          if(continue_btn){
            if(scope.whatsNew.cur_index < scope.whatsNew.agenda_pages.length && (scope.whatsNew.isCustomUnit || scope.whatsNew.agenda_selected_module !== '')){
              return 'agenda_footer_buttons_enabled';
            }else{
              return 'agenda_footer_buttons_disabled';
            }
          }else{
            if(scope.whatsNew.cur_index > 0){
              return 'agenda_footer_buttons_enabled';
            }else{
              return 'agenda_footer_buttons_disabled';
            }
          }
        },
        close: function(){
          scope.show_teacher_info_popup = false;
          scope.whatsNew.reset();
          notificationService.dismissNotification();
        },
        reset: function(){
          scope.whatsNew = {};
          scope.whatsNew = angular.copy(whatsNewTemp);
        }
      }
      var whatsNewTemp = angular.copy(scope.whatsNew);
    }
  }
})
